<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>打破次元壁障，进入《魔法迷域》跨动漫虚空之城，高颜值人气角色全新娘化重构，共赴姬梦之约！AGCN跨界组队，一拳超人和火影忍者能成为航海王？进击的巨人用咒术回战能闯入鬼灭之刃的无限城？龙珠遇上孙悟空谁又能一招制敌？全明星阵容激斗！</p>
    <!-- <pre> -->
    <h2 class="title" style="margin-bottom: 0px">游戏特色</h2>
    <div class="content">
      <div class="content-item">
        <h4>【高颜值暴击 互动贴贴贴】</h4>
        元气甜妹软萌治愈，飒爽御姐暴走狂战，病娇暗黑诡谲神秘，慵懒智者朋克机械，与各类高颜值姬娘互动升温，家园汤泉休憩共泡加战力，温馨小房间举杯摸头，邀约心仪姬娘出游冒险吧！
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【跨IP剧情 多创新玩法】</h4>
        在虚空秘境中，探寻幻灵洞窟，挑战百鬼夜行，次元杀阵妖魔外道，全新式神系统，伺兽陪伴作战，科研所潜能领域研发，秘卷御魂深度加工，歌舞伎町相伴，和娇娘一起加入时空盛典吧！
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【社团欢乐多 躺平就玩爽】</h4>
        好友拜访花园种植，甜品房烘焙制作，社团修炼互助追捕围猎异械，欢乐汇趣味玩法聚合重回童年街机小游戏时代，还有丰富多彩的节日活动，与美少女一起解锁治愈日常！
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【福利全放送 皮肤免费领】</h4>
        告别点点点，内置助手快捷执行日常一键多角色同时升星升级，节奏爽快轻松起号收资源！春日樱花节绿野仙踪裙，夏日海边泳滩排球服，秋日暖阳，冬日和风温泉浴袍，多风格新装直接送！
        <img src="/4.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
